import { useContext } from "react";
import { IContextValueProvider } from "sonobello.utilities.react";

import { UserContext, UserContextProps } from "../../../Context/UserContext";

function UserContextValueProvider<TFulfilledProps, TComponent extends TFulfilledProps>({
  Component,
  map
}: IContextValueProvider<UserContextProps, TFulfilledProps, TComponent>): React.FC<
  Omit<TComponent, keyof TFulfilledProps>
> {
  return componentProps => {
    const contextProps = useContext(UserContext);
    return Component({ ...componentProps, ...map(contextProps) } as unknown as TComponent);
  };
}

export default UserContextValueProvider;
